<template>
  <component v-if="data" :is="themeName" :key="uuidValue" :data="data" />
</template>

<script>
import capitalize from 'lodash/capitalize'
import WebLinkMixin from '@/mixins/weblink'
import { uuid } from '@/helpers'

export default {
  name: 'WebLinKHome',
  data () {
    return {
      title: ''
    }
  },
  metaInfo () {
    const link = document.querySelector("link[rel*='icon']")
    link.href = this.metadata.href
    return {
      title: `Quotation | ${capitalize(this.metadata.image)}`,
      meta: [
        { name: 'description', content: 'Our Quotation Proposal for your group - Including the Itinerary, Pricing, Booking Details & Terms & Conditions', 'data-vue-meta': 0 },
        { property: 'og:title', content: this.metadata.title },
        { property: 'og:site_name', content: 'Quotation' },
        { property: 'og:image', content: this.metadata.image },
        { property: 'og:url', content: this.metadata.url }
      ]
    }
  },
  mixins: [ WebLinkMixin ],
  computed: {
    uuidValue () {
      return uuid()
    },
    metadata () {
      if (this.data) {
        return {
          title: this.data.data.opportunity_name,
          description: this.data.data.reference_number,
          image: this.data.template,
          url: this.data.hash,
          href: `/weblinks/${this.data.template}/img/favicon.ico`
        }
      }
      return 'empty'
    },
    themeName () {
      if (this.data) {
        const prefix = 'WebLink'
        const templateName = capitalize(this.data.template)
        if (templateName) {
          return `${prefix}${templateName}`
        }
        return `${prefix}Default`
        // return 'WebLinkInsightVacations'
      }
      return {}
    }
  }
}
</script>
